module.exports = __webpack_public_path__ + "static/img/4.cc1b2fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/4.png
// module id = +TIe
// module chunks = 13